<template lang="pug">
app-dialog( v-model="$_show" header="Редактировать суд" width="800" )
  v-layout
    expert-court-form( ref="formCourt" :form.sync="form" )
  v-layout( column   )
    v-checkbox( v-model="fillBankAccount" label="Заполнить банковские реквизиты" @change="switchBankAccountForm" ) 
    expert-bank-account-form( v-if="fillBankAccount" ref="formBankAccount" :form.sync="bankAccount" )
  .d-flex.flex-row-reverse
    app-button-action( @click="confirmSave()" ) Сохранить
</template>

<script>
import { AppDialogToggable } from "@/components"
import ExpertCourtForm from "../forms/ExpertCourtForm.vue";
import ExpertBankAccountForm from '../forms/ExpertBankAccountForm.vue';
import { ExpertBankAccount } from '../models/ExpertBankAccount.model';

export default {
  name: "ExpertEditRegionDialog",
  mixins: [AppDialogToggable],

  components: {
    ExpertCourtForm,
    ExpertBankAccountForm
  },

  props: {
    form: null
  },

  data() {
    return {
      fillBankAccount: false,
      bankAccount: null
    }
  },

  methods: {
    $_beforeShow() {
      this.fillBankAccount = !!this.form.bankAccount
      this.bankAccount = this.form.bankAccount
    },

    confirmSave() {
      let isValid = this.fillBankAccount ? this.$refs.formBankAccount.$refs.bankAccountForm.validate() : true
      if (this.$refs.formCourt.$refs.courtForm.validate() && isValid) {
        this.form.bankAccount = this.fillBankAccount ? this.bankAccount : null
        this.$emit('save', this.form)
        this.$_show = false
      }
    },

    switchBankAccountForm() {
      if (this.fillBankAccount) {
        this.bankAccount = new ExpertBankAccount()
      } else {
        this.bankAccount = null
      }
    }
  }
}
</script>